/* eslint-disable no-redeclare */

import { z } from 'zod';

import { Address, Email, FirstName, LastName, UsPhone } from '../primitive';

export const ContactInformation = z
  .object({
    firstName: FirstName,
    lastName: LastName,
    email: Email,
    address: Address,
    phoneNumber: UsPhone,
  })
  .partial();
export type ContactInformation = z.infer<typeof ContactInformation>;
